import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, Redirect, useParams } from "react-router-dom";
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import Breadcrumbs from '../../Breadcrumbs.jsx';
import SubmenuOnPageTop from '../../SubmenuOnPageTop.jsx';
import {
  getPlaylist,
  getPlaylistArrangements,
  deletePlaylist,
  updatePlaylist
} from '../../../actions/collection';
import { addItemToBreadcrumbsArray } from '../../../actions/app';
import { CABINET_SLUG, ARRANGEMENT_TYPE_SLUG } from '../../../../config';
import PlaylistTitle from './PlaylistTitle.jsx';
import ArrangementsList from '../Common/ArrangementsList.jsx';


const CollectionPlaylistArrangements = ({ getPlaylist,
                                          getPlaylistArrangements,
                                          addItemToBreadcrumbsArray,
                                          updatePlaylist, deletePlaylist }) => {
  let {id, lang} = useParams();
  const [playlist, setPlaylist] = useState(null);
  const [redirect, setRedirect] = useState(false);

  useEffect(() => {
    getPlaylist(id).then(response => {
      if (response) {
        setPlaylist(response);
        addItemToBreadcrumbsArray({title: response.name});
      }
    });
  }, []);

  const loadListFromServer = () => { return getPlaylistArrangements(id);}

  const handleUpdate = (data) => {
    updatePlaylist(playlist.id, data);
    setPlaylist(data);
  }
  const handleDelete = (id) => {
    deletePlaylist(id);
    setRedirect(true);
  }

  if (redirect) return <Redirect to={`/${lang}/${CABINET_SLUG}/collection/playlists/`}/>

  let items;
  if (playlist && playlist.count === 0){
    items = <div>
      <p>{ gettext('Этот плейлист еще пуст. Добавьте в него композиции из своей коллекции.') }</p>
      <p><Link to={`/${lang}/${CABINET_SLUG}/collection/${ARRANGEMENT_TYPE_SLUG}/`}>{ gettext('Перейти в мою коллекцию') }</Link></p>
    </div>
  } else{
    items = <ArrangementsList loadListFromServer={ loadListFromServer } redirectTo={ 'playlists' }/>
  }

  return <div>
    <Breadcrumbs />
    { playlist && <PlaylistTitle playlist={ playlist } onUpdate={ handleUpdate } onDelete={ handleDelete }/> }
    <SubmenuOnPageTop/>
    { items }
  </div>
}

CollectionPlaylistArrangements.propTypes = {
  listCount: PropTypes.number.isRequired,
  getPlaylist: PropTypes.func.isRequired,
  getPlaylistArrangements: PropTypes.func.isRequired,
  addItemToBreadcrumbsArray: PropTypes.func.isRequired,
  deletePlaylist: PropTypes.func.isRequired,
  updatePlaylist: PropTypes.func.isRequired,
}

export default compose(
  connect(null, {
    getPlaylist, getPlaylistArrangements,
    addItemToBreadcrumbsArray,
    deletePlaylist, updatePlaylist
  }),
  LoginRequired,
)(CollectionPlaylistArrangements);

